/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../";
export function IconEvents(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M8 5.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5ZM6.75 8a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z\'/><path d=\'M0 1.75v4.692c.82-.327 2 .209 2 1.308C2 8.85.82 9.386 0 9.058v5.192h16V9.058c-.819.327-2-.209-2-1.308 0-1.1 1.18-1.635 2-1.308V1.75H0Zm1.82 8.521C2.59 9.886 3.5 9.026 3.5 7.75c0-1.276-.91-2.136-1.68-2.522-.1-.05-.206-.096-.32-.138V3.25h13v1.84c-.114.042-.22.089-.32.139-.77.385-1.68 1.245-1.68 2.521 0 1.276.91 2.136 1.68 2.521.1.05.206.097.32.14v2.339h-13v-2.34c.114-.042.22-.089.32-.139Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M8 12a4 4 0 1 0 8 0 4 4 0 0 0-8 0Zm4-2a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z\'/><path d=\'M0 3h24v7.038c-1.229-.491-3 .313-3 1.962s1.771 2.453 3 1.962V21H0v-7.036c1.225.503 2.99-.24 3-1.949a1.3 1.3 0 0 0 0-.03c-.01-1.71-1.775-2.452-3-1.95V3Zm2 12.814V19h20v-3.186a4.704 4.704 0 0 1-.619-.255C20.275 15.006 19 13.785 19 12c0-1.785 1.275-3.005 2.381-3.559.19-.094.397-.181.619-.255V5H2v3.186c.222.074.43.16.619.255C3.725 8.995 5 10.215 5 12c0 1.785-1.275 3.005-2.381 3.559-.19.094-.397.181-.619.255Z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconEvents is deprecated and will be archived soon. Use IconEvents instead.
 */
export function Experimental__IconEvents(props) {
  return /*#__PURE__*/React.createElement(IconEvents, props);
}